<template>
  <div class="panel panel-default">
    <div class="panel-body">
      <p class="admin-page-description">
        Atualiza billings da instituição em lote sincronizando com o
        Jacad (sistema externo). Cole os IDs dos painéis dos alunos
        (billings) separados por espaço pra reprocessar e refletir
        mudanças do Jacad.
      </p>
      <div class="updatewith-jacd-view__header">
        <h4><strong>Observações:</strong></h4>
        <ul>
          <li>
            Serão aceitos apenas os IDs dos Painéis dos alunos (Billings)
          </li>
          <li>
            Não inserir IDs de mensalidades e de External IDs
          </li>
          <li>
            Os IDs devem ser separados por espaço
          </li>
        </ul>

        <input
          class="billings-input-field"
          v-model="billingIds"
          placeholder="Ex: 123 456 789"
        >
        <div class="container-button">
          <button
            class="btn btn-primary"
            :disabled="isButtonDisabled"
            variant="secondary"
            @click="updateBillingsWithJacadInBatch"
          >
            Atualizar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillingsService from 'services/BillingsService';

export default {
  data() {
    return {
      billingIds: '',
    };
  },
  computed: {
    isButtonDisabled() {
      return !this.billingIds;
    },
  },
  methods: {
    updateBillingsWithJacadInBatch() {
      BillingsService.updateBillingsWithJacadInBatch(this.billingIds.split(' '))
        .then(() => {
          this.$alert.notifySuccess('Em alguns minutos os painéis serão atualizados.');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao atualizar conforme Jacad');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.billings-input-field {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-top: 20px;
  padding: 10px;
  width: 100%;
}

.btn.btn-primary {
  background-color: #337ab7;
  border-color: #337ab7;
  color: aliceblue;
}

.container-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
